

















































































import { Component, Vue } from "vue-property-decorator";
import { Icon, Button, Field, ActionSheet } from "vant";
import { verifyTradePassword } from "@/utils/verify";
import { getBrowser } from "@/utils/browser";
const browser = getBrowser();
import { goBack } from "@/utils/hybirdMethods";
import CustomSelect from "@/views/create-account/components/CustomSelect.vue";
import customField from "@/components/customField/index.vue";
import navButtons from "@/views/app-pages/components/navButtons.vue";
@Component({
  components: {
    ActionSheet,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Field.name]: Field,
	  CustomSelect,
    customField,
    navButtons
  }
})
export default class Login extends Vue {
  form = {
    password: "",
    new_password: "",
    repeat_password: "",
	account_no:"",
	account_type:""
  };
  accountCurrencyColumns:any = []
  accountPicker:any = false
  future:any = require('@/assets/images/open-account/future.png')
  security:any = require('@/assets/images/open-account/security.png')
  errorStatus:any = false
  activeSelect:any = -1
  rightOK:any = require('@/assets/images/app-pages/right_ok.png')


  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get isDisabledSubmit() {
	if(!(this as any).form.password
	&& !(this as any).form.new_password
	&& !(this as any).form.repeat_password
	&& !(this as any).form.account_no
	){
		return true
	}else{
		return false
	}
    // return Object.keys(this.form).some(key => {
    //   return !this.form[key];
    // });
  }

  created(){
	  this.getAccount();
  }
  getAccount(){
	  (this as any).$apis.getAccountLists().then(res =>{
		  (this as any).accountCurrencyColumns = [];
		  if(res.accountInfo.find(item => item.account_type === 1)){
			  (this as any).form.account_no = res.accountInfo.find(item => item.account_type === 1).account_no;
        (this as any).form.account_type = 1;
		  }

		  res.accountInfo.forEach(item =>{
			  (this as any).accountCurrencyColumns.push({
				  text:`${item.account_type === 1 ? '期货账号' : '证券账号'}(${item.account_no})`,
				  value:item.account_no,
				  type:item.account_type
			  })
		  })

        if((this as any).accountCurrencyColumns.length != 0){
          (this as any).activeSelect = (this as any).accountCurrencyColumns.findIndex(item => item.value == (this as any).form.account_no)
        }


		  // (this as any).accountCurrencyColumns.push({
			 //  text:
		  // })
	  })
  }
  handAccountChange(e,i){
	  let that:any = this;
    that.activeSelect = i
	  that.form.account_no = e.value
	  that.form.account_type = e.type
    that.accountPicker = false
  }


  handleSubmit() {
	if(!(this as any).form.account_no){
		return (this as any).$toast.fail(
		  (this as any).$t(
		    "security_center.trade_password_modify.account_fail_text"
		  )
		);
	}else{
		(this as any).form.account_type = (this as any).accountCurrencyColumns.find(item => item.value == (this as any).form.account_no).type
	}
    if (!verifyTradePassword((this as any).form.new_password)) {
      return (this as any).$toast.fail(
        (this as any).$t(
          "security_center.trade_password_modify.new_password_verify_fail_text"
        )
      );
    }
    if ((this as any).form.repeat_password !== (this as any).form.new_password) {
      return (this as any).$toast.fail(
        (this as any).$t(
          "security_center.trade_password_modify.new_password_repeat_fail_text"
        )
      );
    }
    ((this as any) as any).$apis
      .modifyTradePassword((this as any).form)
      .then(() => {
        // this.$router.push("/electronic-sign");
		if(browser.isApp){
			goBack();
			return
		}

		(this as any).$nextTick(() =>{
			(this as any).form = {
				old_password: "",
				new_password: "",
				repeat_password: ""
			};
		})
		// setTimeout(() =>{
		// 	this.form = {
		// 	  old_password: "",
		// 	  new_password: "",
		// 	  repeat_password: ""
		// 	};
		// },200)
		// setTimeout(() =>{
		// 	(this as any).form = {
		// 	  password: "",
		// 	  new_password: "",
		// 	  repeat_password: ""
		// 	};
		// },200)


        (this as any).$toast((this as any).$t("common.opera_success"));
		// if(browser.isApp){
		// 	goBack();
		// 	return
		// }
      })
      .catch(e => {
        
      });
  }
}
